import { render, staticRenderFns } from "./Websitepage.vue?vue&type=template&id=627c96c9"
import script from "./Websitepage.vue?vue&type=script&lang=js"
export * from "./Websitepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports